import React, { useEffect, useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import Swal from "sweetalert2";

function PagesRegister() {
  const context = useContext(AppSettings);
  const [redirect, setRedirect] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    correo: "",
    contrasena: "",
    confirmar_contrasena: "",
    telefono: "",
    agencias: [],
    modulos: [],
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [agencias, setAgencias] = useState([]);
  const [modulos, setmodulos] = useState([
    { name: "dashboard", label: "Dashboard", selectable: false },
    { name: "analytics", label: "Analytics", selectable: true },
    { name: "form-wizards", label: "Ventas", selectable: true },
    { name: "deals-detail", label: "Deals", selectable: false },
    { name: "deals-inbox", label: "Inbox", selectable: false },
    { name: "deals-compose", label: "Compose", selectable: false },
    { name: "deals-create", label: "Deal Crear", selectable: false },
    { name: "deals-request", label: "Crear solicitud", selectable: true },
    { name: "deals-requests", label: "Resumen", selectable: true },
    { name: "deals-charts", label: "Graficas", selectable: true },
    { name: "deals-ranking", label: "Ranking", selectable: true },
    { name: "deals-invoiced", label: "Facturacion", selectable: true },
    { name: "deals-update", label: "Update", selectable: true },
    { name: "deals-analytics", label: "Deals analytics", selectable: true },
    { name: "deals-tools", label: "Ofertas", selectable: false },
    { name: "deals-contract", label: "Contrato", selectable: false },
    { name: "pos", label: "Inventario", selectable: false },
    { name: "rendimiento", label: "Rendimiento", selectable: true },
    { name: "admin", label: "Admin", selectable: true },
  ]);
  const [loadingAgencias, setLoadingAgencias] = useState(true);
  const [errorAgencias, setErrorAgencias] = useState(null);

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    const fetchAgencias = async () => {
      try {
        const response = await fetch(
          "https://api.checkmark.mx/agencies?access_token=1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3&group=GoCar"
        );
        const result = await response.json();

        if (result.statusCode === 200) {
          setAgencias(result.data.agencies);
        } else {
          setErrorAgencias("Error al obtener las agencias.");
        }
      } catch (error) {
        setErrorAgencias("Error de conexión al obtener las agencias.");
      } finally {
        setLoadingAgencias(false);
      }
    };

    fetchAgencias();

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentClass("");
    };
  }, [context]);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  function handleCheckboxChange(group, event) {
    const { value, checked } = event.target;

    setFormData((prevState) => ({
      ...prevState,
      [group]: checked
        ? [...prevState[group], value]
        : prevState[group].filter((item) => item !== value),
    }));
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const {
      nombre,
      correo,
      contrasena,
      confirmar_contrasena,
      telefono,
      agencias,
      modulos,
    } = formData;

    const accessToken = "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3";

    const payload = {
      nombre,
      correo,
      contrasena,
      confirmar_contrasena,
      telefono,
      agencias,
      modulos,
      access_token: accessToken,
    };

    try {
      const response = await fetch(
        "https://api.checkmark.mx/financiamiento/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();

      // Si el código de respuesta es 200, el registro es exitoso
      if (result.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Registro Exitoso",
          text: result.message || "El usuario se registró correctamente.",
        });
      } else {
        // Si el código de respuesta no es 200, es un error
        if (
          result.statusCode === 400 &&
          result.error &&
          result.error.description
        ) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: result.error.description || "El correo ya está registrado.",
          });
        } else {
          // Si no es un error esperado
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              result.message || "Error desconocido al registrar el usuario.",
          });
        }
      }
    } catch (error) {
      setErrorMessage("Error de conexión con el servidor.");
      Swal.fire({
        icon: "error",
        title: "Error de Conexión",
        text: "Hubo un problema al conectar con el servidor.",
      });
    }
  };

  if (redirect) {
    return <Navigate to="/" />;
  }

  return (
    <div className="register" style={{ width: "100%", height: "100vh" }}>
      <div
        className="register-content"
        style={{ maxWidth: "800px", margin: "auto" }}
      >
        <form onSubmit={handleSubmit}>
          <h1 className="text-center">Registar usuario</h1>
          <p className="text-body text-opacity-50 text-center mb-4">
            Un ID de Admin es todo lo que necesitas para acceder a todos los
            servicios de Admin.
          </p>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <div className="row mb-4">
            <div className="col-md-6">
              <label className="form-label">
                Nombre <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="nombre"
                className="form-control form-control-lg fs-14px"
                placeholder="Ej. Juan Pérez"
                value={formData.nombre}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Dirección de Correo Electrónico{" "}
                <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                name="correo"
                className="form-control form-control-lg fs-14px"
                placeholder="usuario@dominio.com"
                value={formData.correo}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
              <label className="form-label">
                Contraseña <span className="text-danger">*</span>
              </label>
              <input
                type="password"
                name="contrasena"
                className="form-control form-control-lg fs-14px"
                value={formData.contrasena}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Confirmar Contraseña <span className="text-danger">*</span>
              </label>
              <input
                type="password"
                name="confirmar_contrasena"
                className="form-control form-control-lg fs-14px"
                value={formData.confirmar_contrasena}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6">
              <label className="form-label">
                Teléfono <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                name="telefono"
                className="form-control form-control-lg fs-14px"
                value={formData.telefono}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          {/* Agencias */}
          <div className="mb-4">
            <label className="form-label">Selecciona las Agencias</label>
            {loadingAgencias ? (
              <p>Cargando agencias...</p>
            ) : errorAgencias ? (
              <p className="text-danger">{errorAgencias}</p>
            ) : (
              <div className="row">
                {agencias.map((agencia) => (
                  <div className="col-md-4 form-check" key={agencia.ag_id}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`agencia-${agencia.ag_id}`}
                      value={agencia.ag_id}
                      checked={formData.agencias.includes(agencia.ag_id)}
                      onChange={(e) => handleCheckboxChange("agencias", e)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`agencia-${agencia.ag_id}`}
                    >
                      {agencia.nombre}
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Módulos */}
          <div className="mb-4">
            <label className="form-label">Selecciona los Módulos</label>
            <div className="row">
              {modulos.map(
                (module) =>
                  module.selectable && (
                    <div className="col-md-4 form-check" key={module.name}>
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`module-${module.name}`}
                        value={module.name}
                        checked={formData.modulos.includes(module.name)}
                        onChange={(e) => handleCheckboxChange("modulos", e)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`module-${module.name}`}
                      >
                        {module.label}
                      </label>
                    </div>
                  )
              )}
            </div>
          </div>
          <div className="mb-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="customCheck1"
                required
              />
              <label className="form-check-label" htmlFor="customCheck1">
                He leído y acepto los <a href="#/">Términos de Uso</a> y la{" "}
                <a href="#/">Política de Privacidad</a>.
              </label>
            </div>
          </div>
          <div className="mb-3">
            <button
              type="submit"
              className="btn btn-theme btn-lg d-block w-100 mb-3"
            >
              REGISTRAR
            </button>
          </div>
          <div className="text-body text-opacity-50 text-center">
            <Link to="/pages/login">Regresar al inicio</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PagesRegister;
